import { addToLocalStorageObject } from '../../Utils/utils';

const marriedOption = {
  no: 'Single',
  yes: 'Married',
};

export const parseNumberStateToArray = (name, store) => {
  const arrayData = [];
  Object.keys(store).sort().forEach((key) => {
    if (key.includes(name)) {
      arrayData.push(store[key]);
    }
  });
  return arrayData;
};

const setDefaultEmpty = (value, defaultValue, returnUndefined = false) => {
  if (value === undefined) {
    if (returnUndefined) {
      return undefined;
    }
    return defaultValue;
  }
  return value;
};

const parseVehicleState = (array, emptyValue) => {
  const obj = {};
  array.forEach((item, idx) => {
    obj[idx + 1] = {
      year: item.vehicleYear || item.year ? item.vehicleYear || item.year : emptyValue,
      make: item.vehicleMake || item.make ? item.vehicleMake || item.make : emptyValue,
      model: item.vehicleModel || item.model ? item.vehicleModel || item.model : emptyValue,
      trim: item.vehicleTrim || item.trim ? item.vehicleTrim || item.trim : emptyValue,
      vin: item.vin ? item.vin : emptyValue,
      coverageDesired: 'Standard Protection',
      alarmType: emptyValue,
      ownership: emptyValue,
      primaryUse: emptyValue,
      oneWayDistance: emptyValue,
      annualMileage: '12000',
      garageType: emptyValue,
      carAlarm: '1',
      averageMileage: '15',
      vehicleParking: 'Private',
      vehicleFourWheel: '0',
      vehicleAirbags: '1',
      primaryPurpose: 'commute work',
      carLeasedDropdown: 'own',
      comprehensive: '0',
      collision: '0',
    };
  });
  return obj;
};

const parseDriverState = (array, store, returnUndefined, emptyValue) => {
  const obj = {};
  array.forEach((item, idx) => {
    const gender = item.gender && item.gender.toLowerCase();
    const married = item.married && marriedOption[item.married.toLowerCase()] && marriedOption[item.married.toLowerCase()];
    obj[idx + 1] = {
      firstName: item.firstName ? item.firstName : emptyValue,
      lastName: item.lastName ? item.lastName : emptyValue,
      DOB: item.dob ? item.dob : emptyValue,
      gender: setDefaultEmpty(gender, 'male', returnUndefined),
      maritalStatus: setDefaultEmpty(married, 'Married', returnUndefined),
      homeOwner: idx === 0 ? setDefaultEmpty(store.homeOwner, true, returnUndefined) : true,
      primaryRelationship: idx > 0 ? item.additionalDriverRelationship : '-1',
      primaryVehicle: '-1',
      commuteDaysPerWeek: '5',
      driverFullTimeStudent: '0',
      driverFilingRequired: '0',
      driverSuspendedOrRevoked: '0',
      driverDUI_DWI: item.driverDUI_DWI || '0',
      driverMultiplePolicyDiscount: '0',
      driverViolations: '0',
      driverTicketsAccidentsClaimsPast3Years: item.driverTicketsAccidentsClaimsPast3Years || '0',
      driverSalvagedVehicle: '0',
      firstLicensed: '18',
      driverLicenseStatus: 'active',
      education: 'unknown',
      occupation: 'UN',
      sr22: 0,
      bankruptcy: emptyValue,
      repossessions: emptyValue,
      licenseAgeIssued: emptyValue,
      licenseStatus: emptyValue,
      licenseSuspendedOrRevoked: emptyValue,
      licenseState: emptyValue,
      goodStudent: emptyValue,
      requiresSr22: emptyValue,
      creditRating: idx === 0 ? setDefaultEmpty(store.creditRating, 'good', returnUndefined) : 'good',
    };
  });
  return obj;
};

export default (mainStore, autoStore, generatedUUID = '', returnUndefined = false) => {
  const vehicleState = parseNumberStateToArray('vehicleState', autoStore);
  const driverState = parseNumberStateToArray('driverState', autoStore);
  const emptyValue = returnUndefined ? undefined : '';
  addToLocalStorageObject(
    'tyTitleOptions',
    {
      firstName: driverState[0].firstName,
      lastName: driverState[0].lastName,
      city: autoStore.city,
      state: autoStore.state,
    },
  );
  return ({
    user_agent: mainStore.urlParams.user_agent || '',
    referrer: mainStore.referrer || '',
    zipSubmitSubmitForm: mainStore.variantObject.form || '??',
    zipSubmitSubmitVariant: mainStore.variantObject.variant || '??',
    form: mainStore.variantObject.form,
    urlVariantOverride: mainStore.urlVariantOverride,
    variant_number: mainStore.variantObject.variant,
    logo: mainStore.logo,
    tyType: mainStore.tyType,
    device: mainStore.device,
    brand: mainStore.brand,
    debug: mainStore.debug,
    defaultDomain: mainStore.defaultDomain,
    showAddressPage: mainStore.showAddressPage,
    affid: mainStore.affid,
    ip: mainStore.ip,
    uuid: mainStore.uuid !== '' ? mainStore.uuid : generatedUUID,
    siteID: mainStore.siteID,
    trafficApproved: mainStore.trafficApproved,
    inboundNumber: mainStore.inboundNumber,
    entry_time: mainStore.entry_time,
    thStep: mainStore.thStep,
    site_id: mainStore.site_id,
    currentPage: autoStore.currentPageName ? autoStore.currentPageName : true,
    lastStepTracked: returnUndefined ? '' : 'phone',
    currentlyInsured: autoStore.currentlyInsured,
    loadedCityState: false,
    militaryDiscount: false,
    vehicleCount: autoStore.vehicleCount || undefined,
    coverage: {
      driverCount: autoStore.driverCount || emptyValue,
      monthsInsured: 6,
      currentInsuranceCarrier: autoStore.currentlyInsured ? autoStore.insuredCompanyList : emptyValue,
      policyExpiration: '7',
      lengthOfInsurances: '72',
      currentlyInsured: autoStore.currentlyInsured || emptyValue,
    },
    coreg: {
      // eslint-disable-next-line
      bundleHomeInsurance: autoStore.coreg ? setDefaultEmpty(autoStore.homeOwner !== false, false, returnUndefined) : returnUndefined ? undefined : false,
      // eslint-disable-next-line
      bundleRenterInsurance: autoStore.coreg ? setDefaultEmpty(autoStore.homeOwner === false, false, returnUndefined) : returnUndefined ? undefined : false,
      ownedHome: autoStore.ownedHome || emptyValue,
      squareFeet: autoStore.homeSize || autoStore.squareFeet || emptyValue,
      yearBuilt: (autoStore.whenHomeWasBuilt || autoStore.propertyYear || autoStore.yearBuilt || '-1').toString(),
      dwellingType: autoStore.dwellingType || 'Single Family',
      propertyCoverage: autoStore.propertyCoverage || 15000,
    },
    contact: {
      lengthOfHomeOwnership: autoStore.lengthOfHomeOwnership || '24',
      streetAddress: autoStore.address || emptyValue,
      city: autoStore.city || emptyValue,
      state: autoStore.state || emptyValue,
      zipCode: autoStore.zip || emptyValue,
      email: autoStore.email || emptyValue,
      phone: autoStore.phone || emptyValue,
      languagePref: 'english',
      phoneConsent: '1',
    },
    driverState: parseDriverState(driverState, autoStore, returnUndefined, emptyValue),
    vehicleState: parseVehicleState(vehicleState, emptyValue),
    lead_id: document.getElementById('leadid_token').value || 'debug_mode_no_lead_id',
    trustedForm: (!!document.getElementById('xxTrustedFormToken_0') && document.getElementById('xxTrustedFormToken_0').value) || 'debug_mode_no_trusted_form',
    action: 'submit_auto_savings',
  });
};
